import * as React from "react";

const AiSentimentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
      stroke="black"
      strokeOpacity="0.88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.80078 11.6016C6.80078 11.6016 8.00078 13.2016 10.0008 13.2016C12.0008 13.2016 13.2008 11.6016 13.2008 11.6016M7.60078 7.60156H7.60878M12.4008 7.60156H12.4088"
      stroke="black"
      strokeOpacity="0.88"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default AiSentimentIcon;
